import React, { useState } from "react";
import { DataProvider } from '../../../../../../../components/Integration/DataConnections/DataProvider';
import DataConnectPage from './DataConnectPage';
import McpToolsPage from './McpToolsPage';
import { Tab } from "semantic-ui-react";

const DataConnect = (props) => {
  const isOutbound = props.bot_type === "OUTBOUND";

  // If not OUTBOUND, show only Function Tools
  if (!isOutbound) {
  return (
	<DataProvider>
		<DataConnectPage 
		workspace_id={props.workspace_id}
		/>
	</DataProvider>
  );
  }

  // For OUTBOUND workspaces, show both tabs
  const panes = [
    {
      menuItem: 'Function Tools',
      render: () => (
        <Tab.Pane>
          <DataProvider>
            <DataConnectPage
              workspace_id={props.workspace_id}
            />
          </DataProvider>
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'MCP Tools',
      render: () => (
        <Tab.Pane>
          <McpToolsPage
            workspace_id={props.workspace_id}
          />
        </Tab.Pane>
      ),
    },
  ];

  return <Tab panes={panes} />;
};

export default DataConnect;
